import logo from "../Assests/bookinindia-logo-optimized.png";

export default function AppSplash() {
  return (
    <div className="app-splash" role="status" aria-label="Loading BookinIndia">
      <style>{`
        .app-splash {
          position: fixed;
          inset: 0;
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #ffffff;
          overflow: hidden;
        }

        .app-splash::before {
          content: "";
          position: absolute;
          inset: -30%;
          background:
            radial-gradient(circle at 30% 30%, rgba(231, 18, 4, 0.14), transparent 28%),
            radial-gradient(circle at 70% 70%, rgba(255, 138, 76, 0.16), transparent 30%);
          animation: splashGlow 2s ease-in-out infinite alternate;
        }

        .app-splash__content {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 18px;
          padding: 28px;
        }

        .app-splash__logo-wrap {
          width: 150px;
          height: 150px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 32px;
          background: rgba(255, 255, 255, 0.84);
          box-shadow: 0 24px 60px rgba(231, 18, 4, 0.18);
          animation: splashPop 1.35s ease-in-out infinite;
        }

        .app-splash__logo {
          width: 132px;
          height: 132px;
          object-fit: contain;
          display: block;
        }

        .app-splash__text {
          font-size: 15px;
          font-weight: 800;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #111827;
        }

        .app-splash__bar {
          width: 180px;
          height: 4px;
          border-radius: 999px;
          background: #fee2e2;
          overflow: hidden;
        }

        .app-splash__bar::after {
          content: "";
          display: block;
          width: 45%;
          height: 100%;
          border-radius: inherit;
          background: linear-gradient(90deg, #e71204, #ff7a45);
          animation: splashLoad 1.15s ease-in-out infinite;
        }

        @keyframes splashPop {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        @keyframes splashLoad {
          0% { transform: translateX(-110%); }
          100% { transform: translateX(240%); }
        }

        @keyframes splashGlow {
          from { transform: rotate(0deg) scale(1); }
          to { transform: rotate(8deg) scale(1.04); }
        }

        @media (max-width: 640px) {
          .app-splash__logo-wrap {
            width: 124px;
            height: 124px;
            border-radius: 28px;
          }

          .app-splash__logo {
            width: 108px;
            height: 108px;
          }
        }
      `}</style>
      <div className="app-splash__content">
        <div className="app-splash__logo-wrap">
          <img className="app-splash__logo" src={logo} alt="BookinIndia" />
        </div>
        <div className="app-splash__text">BookinIndia</div>
        <div className="app-splash__bar" />
      </div>
    </div>
  );
}
